import { createSlice } from "@reduxjs/toolkit";
import { personalFundraiserAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const personalFundraiserSlice = createSlice({
  name: "personalFundraiser",
  initialState: data,
  reducers: {
    personalFundraiserSlice(state) {
      state.isLoading = true;
    },
    personalFundraiserSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = null;
    },
    personalFundraiserSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    personalFundraiserSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const personalFundraiserHandler = (user_id: string) => async (dispatch: any) => {
  try {
    dispatch(personalFundraiserAction.personalFundraiserSlice());
    const response: any = await personalFundraiserAPI(user_id);
    dispatch(personalFundraiserAction.personalFundraiserSliceSuccess(response));
  } catch (e: any) {
    dispatch(personalFundraiserAction.personalFundraiserSliceFailure(e?.response?.data?.message));
    dispatch(personalFundraiserAction.personalFundraiserSliceReset());
  }
};
export default personalFundraiserSlice.reducer;
export const personalFundraiserAction = personalFundraiserSlice.actions;
